const executiveNameLibrary = {
    collaboration: "Collaboration days",
    code: "Code days",
    breakTime: "Total Breaks",
    oooBreak: "Breaks (per user-work day)",
    ooo: "Out of Office",
    balanceSum: "Balance Days",
    throughputGit: "Pull Requests Merged",
    throughputPm: "Tickets Done",
    leadTimeGit: "PR Lead Time",
    leadTimeGit90th: "PR Lead Time(90th)",
    leadTimeGit95th: "PR Lead Time(95th)",
    leadTimeGitAdj: "PR Lead Time(95th)",
    leadTimeGitMedian: "PR Lead Time(95th)",
    leadTimePm: "Issues Lead Time",
    leadTimePm90th: "Issues Lead Time(90th)",
    leadTimePm95th: "Issues Lead Time(95th)",
    leadTimePmAdj: "PR Lead Time (outliers removed)",
    leadTimePmMedian: "Issues Lead Time",
    reviewToMergeTimeGit: "Review to merge",
    reviewToMergeTimeGit90th: "Review to merge(90th)",
    reviewToMergeTimeGit95th: "Review to merge(95th)",
    reviewToMergeTimeGitAdj: "Review to merge (outliers removed)",
    reviewToMergeTimeGitMedian: "Review to merge(Median)",
    longHours: "Long Working Hours",
    outOfHours: "Out of hours working",
    focus: "Available Focus Time",
    backlog: "Issues in backlog",
    prodBacklog: "Prod issues in backlog",
    bugsBacklog: "Bug issues in backlog",
    prodBugsBacklog: "Prod Bug issues in backlog",
    issues: "Bugs detected",
    prodIssues: "Production Bugs detected",
    issuePoints: "Production Bug Points detected",
    prodIssuePoints: "Issue points in production",
    totalIssuePoints: "Total issue points",
    totalIssues: "Total issues",
    totalProdIssuePoints: "Total issue points in production",
    totalProdIssues: "Total issues in production",
    lines: "All lines",
    nonReworkLines: "New lines",
    reworkLines: "Reworked lines",
    reworkLinesRatio: "Reworked code ratio",
    commits: "Commits",
    maintainabilityInfluence: "Maintainability influence",
    count: "Single Contributor Repos",
};

export default executiveNameLibrary;
